import { CButtonClassname, EButtonColor, HeroSection, SectionTitle } from '@web_opxp/components';
import { renderStringToReact, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { WELCOME_ANCHOR } from '../../base/constants';
import { AssetsBaseUrl } from '../../base/env';
import './DiscoverSection.scss';

export interface IProps {
  onGetStarted: (event: React.MouseEvent) => void;
}

const DiscoverSection: React.FC<IProps> = ({ onGetStarted }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.DiscoverSection.Title');
  const content = renderStringToReact(t('prereg:Welcome.DiscoverSection.ContentHtml'));
  const imgSrc = `${AssetsBaseUrl}/feature/thinking_1.png`;
  return (
    <HeroSection imgSrc={imgSrc} className="discover-section">
      <SectionTitle>{title}</SectionTitle>
      {content}
      <a href={`#${WELCOME_ANCHOR}`} className={`${CButtonClassname} ${EButtonColor.white}`} onClick={onGetStarted}>
        {t('prereg:Welcome.DiscoverSection.Action')}
      </a>
    </HeroSection>
  );
};

export default DiscoverSection;
